namespace Gamification.Gamification {
    export namespace UtentiProdottiBadgeService {
        export const baseUrl = 'Gamification/UtentiProdottiBadge';

        export declare function Create(request: Serenity.SaveRequest<UtentiProdottiBadgeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiProdottiBadgeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiProdottiBadgeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiProdottiBadgeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiProdottiBadge/Create",
            Update = "Gamification/UtentiProdottiBadge/Update",
            Delete = "Gamification/UtentiProdottiBadge/Delete",
            Retrieve = "Gamification/UtentiProdottiBadge/Retrieve",
            List = "Gamification/UtentiProdottiBadge/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiProdottiBadgeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
